import { useReportingContext } from 'modules/iterableGoals/contexts';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { Reporting } from 'modules/iterableGoals/types';
import { LargeSegmentedControl } from 'ui/segmentedControl';

export const ReportingToggle = () => {
  const { reportingBy, updateReportingBy } = useReportingContext();
  const { t } = useGoalsTranslations();
  const options = [
    {
      value: Reporting.EVENT,
      name: t('revenue.toggle.event'),
    },
    {
      value: Reporting.REVENUE,
      name: t('revenue.toggle.revenue'),
    },
  ];

  return (
    <LargeSegmentedControl
      options={options}
      onSelect={(value) => {
        updateReportingBy(value);
      }}
      value={reportingBy}
    />
  );
};
